
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("ffvXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $760408f5b57437de$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $1EmDK = parcelRequire("1EmDK");

var $dXq4S = parcelRequire("dXq4S");

var $dAfqg = parcelRequire("dAfqg");

var $DVljb = parcelRequire("DVljb");

var $9OXo1 = parcelRequire("9OXo1");

var $4HJKb = parcelRequire("4HJKb");
const $760408f5b57437de$var$entryPointParams = {};
const $760408f5b57437de$var$DevDetailsDialogLoader = (props)=>{
    const { onCloseDevDetailDialog: onCloseDevDetailDialog, state: state, actions: actions } = props;
    const hookedLocale = (0, $DVljb.useLocale)();
    const { issueId: issueId, issueKey: issueKey, locale: locale, dataTypeSelected: dataTypeSelected, isDevPanelDetailsDialogShown: isDevPanelDetailsDialogShown, legacyDevPanelDetailsDialogShownCounter: legacyDevPanelDetailsDialogShownCounter, legacyData: legacyData } = state ?? {};
    const { closeDetailDialog: closeDetailDialog, updateState: updateStateAction } = actions ?? {};
    const onClose = (0, $5uXOq.useCallback)(()=>{
        onCloseDevDetailDialog();
        closeDetailDialog();
    }, [
        closeDetailDialog,
        onCloseDevDetailDialog
    ]);
    const dialogBridge = (0, $5uXOq.useRef)(null);
    const currentLegacyDevPanelDetailsDialogShownCounter = (0, $5uXOq.useRef)(legacyDevPanelDetailsDialogShownCounter);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $1EmDK.developmentDetailsDialogEntrypoint), $760408f5b57437de$var$entryPointParams);
    // https://hello.atlassian.net/wiki/spaces/JIE/pages/4772823699/LDR+Entrypoint+Load+Via+Hooks+For+Faster+Experimentation
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isDevPanelDetailsDialogShown) entryPointActions.load();
    }, [
        entryPointActions,
        isDevPanelDetailsDialogShown
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const updatedState = {
            locale: hookedLocale
        };
        updateStateAction(updatedState);
    }, [
        hookedLocale,
        updateStateAction
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /** Valid cases
		 *  When dialog is open
		 *  AND
		 *  issueId is a non empty string
		 *  AND
		 *  issueKey is a string
		 */ const isShowingDialog = isDevPanelDetailsDialogShown || currentLegacyDevPanelDetailsDialogShownCounter.current !== legacyDevPanelDetailsDialogShownCounter;
        const hasValidIssueId = typeof issueId === 'string' && issueId !== '';
        if (isShowingDialog && !hasValidIssueId) throw new Error('Could not find a valid "issueId" value.');
    }, [
        isDevPanelDetailsDialogShown,
        issueId,
        issueKey,
        legacyDevPanelDetailsDialogShownCounter,
        updateStateAction
    ]);
    (0, $5uXOq.useEffect)(()=>{
        async function waitforBridge() {
            await (0, $4HJKb.loadDialogBridge)().then((bridge)=>{
                dialogBridge.current = bridge;
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                dialogBridge.current.showDialog(issueKey ?? '', issueId ?? '', legacyData, dataTypeSelected, false);
            }).catch((exception)=>{
                throw exception;
            });
        }
        if (currentLegacyDevPanelDetailsDialogShownCounter.current !== legacyDevPanelDetailsDialogShownCounter) {
            currentLegacyDevPanelDetailsDialogShownCounter.current = legacyDevPanelDetailsDialogShownCounter;
            if (dialogBridge.current) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            dialogBridge.current.showDialog(issueKey ?? '', issueId ?? '', legacyData, dataTypeSelected, false);
            else waitforBridge();
        }
    }, [
        legacyData,
        dataTypeSelected,
        dialogBridge,
        issueId,
        issueKey,
        legacyDevPanelDetailsDialogShownCounter
    ]);
    const projectContext = (0, $dAfqg.useProjectContext)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const projectAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        resourceType: 'project',
        cloudId: tenantContext.cloudId,
        resourceId: projectContext.data?.projectId?.toString() ?? ''
    });
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            issueId: issueId ?? '',
            issueKey: issueKey ?? '',
            baseUrl: '',
            locale: locale,
            selectedTab: dataTypeSelected,
            showRemoteLinks: true,
            onCloseDialog: onClose,
            projectAri: projectAri || '',
            accountId: tenantContext.atlassianAccountId || ''
        }), [
        dataTypeSelected,
        issueId,
        issueKey,
        locale,
        onClose,
        projectAri,
        tenantContext.atlassianAccountId
    ]);
    return isDevPanelDetailsDialogShown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "dev-panel-details-loader",
        packageName: "jira-development-details-loader",
        fallback: null,
        // @ts-expect-error - TS2322 - Type 'Locale | undefined' is not assignable to type 'Locale'.
        runtimeProps: runtimeProps
    }) : null;
};
$760408f5b57437de$var$DevDetailsDialogLoader.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    scopeId: ''
};
const $760408f5b57437de$var$DevDetailDialogLoaderWithContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4HJKb.DevOpsDetailsDialogLoaderContainer), {
        scope: props.scopeId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4HJKb.DevOpsDetailsDialogLoaderSubscriber), null, (state, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($760408f5b57437de$var$DevDetailsDialogLoader, {
            state: state,
            actions: actions
        })));
$760408f5b57437de$var$DevDetailDialogLoaderWithContainer.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $760408f5b57437de$export$2e2bcd8739ae039 = $760408f5b57437de$var$DevDetailDialogLoaderWithContainer;

});
parcelRegister("1EmDK", function(module, exports) {

$parcel$export(module.exports, "developmentDetailsDialogEntrypoint", () => $8eba7abfc17b83a7$export$f7911756e4399dac);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $8eba7abfc17b83a7$export$f7911756e4399dac = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("amCCo")).then((module)=>module.DevelopmentDetailsDialogEntryPoint), {
        moduleId: "26fa735d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("amCCo", function(module, exports) {

let $78b9ea3734e96dad$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $78b9ea3734e96dad$var$load("76n7a"),
    $78b9ea3734e96dad$var$load("l253H"),
    $78b9ea3734e96dad$var$load("xadHg")
]).then(()=>parcelRequire('b7Gp9'));

});




$parcel$global.rlb("84z1X")
//# sourceMappingURL=ui.55eb45e9.js.map
